<template>
  <div>
    <special-header pagetype="index"></special-header>



    <div class=" pb-40 bg-f7">
      <div class="pt-30 flex">
        <!-- 面包屑 -->
        <div class="flex flex-x-s  f-14 c-33 w1380 m-auto">
          <span class="iconfont icontubiao-dingwei"></span>
          <span>合肥市文化和旅游局</span>
          <span class="iconfont iconxiangyoujiantou"></span>
          <span>专题</span>

        </div>
      </div>

      <ul class="w1380  special-list flex flex-y-s">
        <li class="special-list-detail mt-30" @click="enterSpecial(item.DOC_SOURCEURL)" v-for="item, index in zt_arr"
          :key="index">
          <img class="specail-img" :src="item.pub_picBig" alt="" />
          <div>
            <p class="p-15 onelist title f-16 c-33">{{ item.XINWENZIXUN_SYS_TOPIC }}</p>
            <div class="flex-dir-col flex-y-e bg-ff p-30">
              <p class="f-14 c-33 list3 w100">{{ item.XINWENZIXUN_REMARK }}</p>
              <img class="specail-icon mt-20" src="../assets/images/specail_icon.png" alt="" />
            </div>
          </div>
        </li>
      </ul>

      <div class="flex-c flex mt-40">
        <Page :total="total" :page-size="9" @on-change="changePage" />
      </div>
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import specialHeader from './specialHeader.vue';
import headerView from './header.vue'
import footerView from './footer.vue'

export default {
  data() {
    return {
      special_list: [],
      special: [],
      total: 0,
      zt_arr: []
    }
  },

  components: {
    headerView,
    footerView,
    specialHeader
  },

  created() {
    document.title = this.$route.query.name
  },

  mounted() {
    // this.specialList()
    this.getztList()
  },

  methods: {
    // 获取首页专题列表
    async getztList() {
      let _this = this;
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 154 }, { pub_sale_status: 1 }]),
        orderBy: 'pub_a_order asc pub_lastmodified desc id asc',
        pageNo: 1,
        pageSize: 15,
        searchText: ''
      };
      const res = await _this.post('/spc/cms/publish/list.do', data);
      // console.log(res)
      if (res.success) {
        res.result.forEach(x => {
          x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE);
          x.year = x.date.substr(0, 4);
          x.mon = x.date.substr(5, 2);
          x.day = x.date.substr(8, 2);
        });
        _this.zt_arr = res.result;
        _this.total = res.totalCount
        console.log("专题数据", _this.zt_arr);
      } else {
        _this.$Message.error(res.description);
      }
    },
    // 专题列表
    async specialList(page = 1) {
      let _this = this
      this.$Spin.show()
      let data = {
        conditions: JSON.stringify([{ pub_col_id: 108 }, { pub_sale_status: 1 }]),
        orderBy: "pub_a_order asc pub_lastmodified desc id asc",
        pageNo: page,
        pageSize: 9,
        searchText: "",
      }
      const res = await _this.post('/spc/cms/publish/list.do', data)
      // console.log(res)
      if (res.success) {
        res.result.forEach(x => {
          x.date = _this.util.formatDate(x.XINWENZIXUN_PUB_DATE)
          x.year = x.date.substr(0, 4)
          x.mon = x.date.substr(5, 2)
          x.day = x.date.substr(8, 2)
        })
        _this.special_list = res.result
        _this.total = res.totalCount
      } else {
        // _this.$Message.error(res.description);
      }

      this.$Spin.hide()
    },

    // 跳转专题详情
    enterSpecial(src) {
      let index = src.lastIndexOf('=')
      let topicId = src.substr(index + 1)
      let url = src.substr(0, index)
      if (url != this.$baseURL + '/special_detail?id') {
        return window.open(src)
      }
      // this.$router.push({path:'/special_detail',query: {topicId}})

      let link = this.$router.resolve({
        path: '/special_detail',
        query: { topicId }
      });
      window.open(link.href, "_blank"); //打开新窗口
    },

    // 改变页码
    changePage(page) {
      this.specialList(page)
    }
  }
}
</script>

<style lang="less" scoped>
.w1380 {
  width: 1380px;
  margin: 0 auto;
}

.iconxiangyoujiantou {
  color: #333;
  font-size: 14px;
}

.special-list::after {
  content: '';
  width: 440px;
}

.special-list-detail {
  width: 440px;
  cursor: pointer;

  .specail-img {
    width: 100%;
    height: 260px;
  }

  .title {
    background-color: #efe9e9;
  }

  .list3 {
    text-indent: 2em;
    line-height: 1.8;
  }

  .specail-icon {
    width: 50px;
    height: 31px;
  }
}
</style>
